//_api
import Login from "./Login_Register/Login";
import Permission from "./Login_Register/Permission";
import Package_Data from "./Get_Data/packages_data";
import Product from "./Product";
import Pawn from "./Pawn";
import Super_Admin from "./SuperAdmin";
import MarketPlace from "./MarketPlace";
import Report from "./Report";
import ProvinceTHService from "./Get_Data/province_th";
import BuyCarService from "./Car/buyCar";
import PawnCarService from "./Car/pawnCar";
import CarService from "./Car";
import ReadySellCarService from "./Car/readySellCar";
import ConsignmentCarService from "./Car/consignmentCar";
import SoldeCarService from "./Car/soldCar";
import ListByCustomerCarService from "./Car/listByCustomerCar";
import SettingPriceCarService from "./Car/settingPriceCar";
import CustomerCarService from "./Car/customerCar";
import CarReportService from "./Car/reportCar";

const useApi = {
  login: Login,
  permission: Permission,
  packages_data: Package_Data,
  product: Product,
  super_admin: Super_Admin,
  pawn: Pawn,
  marketplace: MarketPlace,
  report: Report,
  province: ProvinceTHService,
  car: CarService,
  buy_car: BuyCarService,
  pawn_car: PawnCarService,
  ready_car: ReadySellCarService,
  consignment_car: ConsignmentCarService,
  sold_car: SoldeCarService,
  list_by_customer_car: ListByCustomerCarService,
  setting_price_car: SettingPriceCarService,
  customer_car: CustomerCarService,
  car_report: CarReportService,
};
export default useApi;
